export default {
    skipDateBlockingAlert() {
        return this.$store.state.skipDateBlockingAlert
    }
}